import React from 'react';
import './RoundHeader.css';

const RoundHeader = ({ title, pointValue, description = 'point pr. korrekt vinder' }) => (
  <div className="round-header">
    <h4>{title}</h4>
    <p>{pointValue} {description}</p>
  </div>
);

export default RoundHeader;
